import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Canceled: {{reason}}',
    fulfilled: 'This order has been successfully fulfilled',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Not accepted',
    [OrderRejectionReason.ClosingSoon]: 'Closing soon',
    [OrderRejectionReason.ItemUnavailable]: 'Item unavailable',
    [OrderRejectionReason.OrderTooBig]: 'Order too big',
    [OrderRejectionReason.CustomerMistake]: 'Customer mistake',
    [OrderRejectionReason.Other]: 'Other',
    fully_refunded: 'Order was completely refunded',
  },
};
